import React from "react";
import {Col, FormGroup, Row} from "reactstrap";
import {useSelector} from "react-redux";
import {getSimUsageDetails} from "../../../../redux/Selectors/sim.selector";

function SimPlansInformation(_props, ref) {
  const simUsageDetails = useSelector(getSimUsageDetails);
  const simUsageData = simUsageDetails ? simUsageDetails : {};

  React.useImperativeHandle(ref, () => {
    return {
      state: {},
    };
  });
  const {ratePlan = "", communicationPlan = ""} = simUsageData;
  return (
    <div className="pl-lg-4">
      <ul>
        <Row>
          <Col md="12">
            <li>
              <FormGroup>
                <label className="form-control-label" htmlFor="input-name">
                  RATE:
                </label>
                <label
                  className="form-control-label sim-usage-label-value"
                  htmlFor="input-name"
                >
                  {ratePlan ? ratePlan : "NA"}
                </label>
              </FormGroup>
            </li>
          </Col>
        </Row>
        <Row>
          <Col md="12">
            <li>
              <FormGroup>
                <label className="form-control-label" htmlFor="input-name">
                  COMMUNICATION:
                </label>
                <label
                  className="form-control-label sim-usage-label-value"
                  htmlFor="input-name"
                >
                  {communicationPlan ? communicationPlan : "NA"}
                </label>
              </FormGroup>
            </li>
          </Col>
        </Row>
      </ul>
    </div>
  );
}

export default React.forwardRef(SimPlansInformation);
